import React, { forwardRef } from 'react';
import ReactDatePicker, { ReactDatePickerProps, registerLocale, setDefaultLocale } from 'react-datepicker';
import { enGB, enUS, de, es, fr, frCH, it, nl, nlBE, pt, sv } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { TextInput, TextInputProps } from '../text-input';

import './react-datepicker.scss';

registerLocale('en-US', enUS);
registerLocale('en-GB', enGB);
registerLocale('de-DE', de);
registerLocale('de-CH', de);
registerLocale('es-ES', es);
registerLocale('fr-FR', fr);
registerLocale('fr-BE', fr);
registerLocale('fr-CH', frCH);
registerLocale('it-IT', it);
registerLocale('it-CH', it);
registerLocale('nl-NL', nl);
registerLocale('nl-BE', nlBE);
registerLocale('pt-PT', pt);
registerLocale('sv-SE', sv);

setDefaultLocale('de');

const CustomInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => <TextInput {...props} ref={ref} />);
CustomInput.displayName = 'DatePicker';

export interface DatePickerProps extends ReactDatePickerProps, Pick<TextInputProps, 'message' | 'isInvalid'> {
  customInputIcon?: TextInputProps['icon'];
  label: string;
  id: string;
}

export const DatePicker: React.FC<DatePickerProps> = (props) => (
  <ReactDatePicker
    {...props}
    customInput={
      <CustomInput
        icon={props.customInputIcon}
        id={props.id}
        isInvalid={props.isInvalid}
        label={props.label}
        message={props.message}
        value={props.value}
      />
    }
  />
);
